import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type { LoginOrSignupDataQuery, LoginOrSignupDataQueryVariables } from './api.graphql';
import { LoginOrSignupData } from './api.graphql';

export type LoginOrSignupPageData = LoginOrSignupDataQuery;

export async function getLoginOrSignupPageData({ gql: { fetch } }: UtilityContext): Promise<LoginOrSignupPageData> {
	const { data } = await fetch<LoginOrSignupDataQuery, LoginOrSignupDataQueryVariables>({
		query: LoginOrSignupData,
		rejectOnError: true,
	});

	return {
		...data,
	};
}
